import React from 'react';
import { Clock, AlertCircle } from 'lucide-react';
interface HoldsTabProps {
  onSelectQuote: (id: string) => void;
  quotes: any[];
}
export function HoldsTab({
  onSelectQuote,
  quotes
}: HoldsTabProps) {
  const activeHolds = quotes.filter(q => q.status === 'Held').sort((a, b) => a.expiryHours - b.expiryHours);
  return <div className="space-y-8 animate-in fade-in duration-500" data-id="element-390">
      <div data-id="element-391">
        <h1 className="font-serif text-3xl text-stone-900 mb-2" data-id="element-392">
          Active Holds
        </h1>
        <p className="text-stone-500" data-id="element-393">
          Monitor inventory currently held for groups. Holds expire
          automatically.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-394">
        {activeHolds.length > 0 ? activeHolds.map(hold => {
        const isUrgent = hold.expiryHours < 24;
        return <div key={hold.id} onClick={() => onSelectQuote(hold.id)} className={`bg-white p-6 border shadow-sm cursor-pointer transition-all hover:-translate-y-1 ${isUrgent ? 'border-red-200 hover:border-red-400 hover:shadow-md' : 'border-stone-200 hover:border-stone-300'}`} data-id="element-395">
                <div className="flex justify-between items-start mb-4" data-id="element-396">
                  <p className="font-mono text-xs uppercase tracking-widest text-stone-500" data-id="element-397">
                    {hold.id}
                  </p>
                  <span className={`flex items-center text-xs font-mono px-2 py-1 rounded border ${isUrgent ? 'text-red-700 bg-red-50 border-red-200' : 'text-amber-700 bg-amber-50 border-amber-200'}`} data-id="element-398">
                    {isUrgent ? <AlertCircle className="w-3 h-3 mr-1" data-id="element-399" /> : <Clock className="w-3 h-3 mr-1" data-id="element-400" />}
                    {hold.expiryHours}h left
                  </span>
                </div>

                <h3 className="font-serif text-xl text-stone-900 mb-1" data-id="element-401">
                  {hold.groupName}
                </h3>
                <p className="text-sm text-stone-500 mb-6" data-id="element-402">{hold.agency}</p>

                <div className="space-y-3 mb-6" data-id="element-403">
                  <div className="flex justify-between text-sm" data-id="element-404">
                    <span className="text-stone-500" data-id="element-405">Property</span>
                    <span className="font-medium text-stone-900" data-id="element-406">
                      {hold.property}
                    </span>
                  </div>
                  <div className="flex justify-between text-sm" data-id="element-407">
                    <span className="text-stone-500" data-id="element-408">Inventory</span>
                    <span className="font-medium text-stone-900" data-id="element-409">
                      {hold.rooms} Rooms
                    </span>
                  </div>
                  <div className="flex justify-between text-sm" data-id="element-410">
                    <span className="text-stone-500" data-id="element-411">Value</span>
                    <span className="font-mono text-stone-900" data-id="element-412">
                      ${hold.value.toLocaleString()}
                    </span>
                  </div>
                </div>

                <div data-id="element-413">
                  <div className="flex justify-between text-xs font-mono text-stone-500 mb-2" data-id="element-414">
                    <span data-id="element-415">Hold Placed</span>
                    <span data-id="element-416">Auto-Release</span>
                  </div>
                  <div className="w-full bg-stone-100 h-2 rounded-full overflow-hidden" data-id="element-417">
                    <div className={`h-full rounded-full ${isUrgent ? 'bg-red-500' : 'bg-amber-500'}`} style={{
                width: `${hold.expiryHours / 72 * 100}%`
              }} data-id="element-418" />
                  </div>
                </div>
              </div>;
      }) : <div className="col-span-full bg-white border border-stone-200 p-12 text-center" data-id="element-419">
            <Clock className="w-12 h-12 text-stone-300 mx-auto mb-4" data-id="element-420" />
            <h3 className="font-serif text-xl text-stone-900 mb-2" data-id="element-421">
              No Active Holds
            </h3>
            <p className="text-stone-500" data-id="element-422">
              There is currently no inventory being held for groups.
            </p>
          </div>}
      </div>
    </div>;
}